/**
 * Synthesized by `apps/lfe/src/custom-sw.js` when a `/api/**` fetch fails at
 * the network layer. Distinguishes a dead connection from a real `504` sent by
 * the API gateway, which `ngsw-worker.js` would otherwise be indistinguishable
 * from (it synthesizes `504` for network failures itself).
 *
 * Status `0` still occurs when the service worker is inactive (local `docker`
 * config, unsupported browser, first load) or when the request opted out via
 * the `ngsw-bypass` header — handle both.
 */
export const SW_NETWORK_ERROR_STATUS = 599;

/** Marker header set by `custom-sw.js` on the synthesized {@link SW_NETWORK_ERROR_STATUS} response. */
export const SW_NETWORK_ERROR_HEADER = 'X-SW-Network-Error';

/**
 * `true` when the request never got an HTTP answer: `599` from the service
 * worker, or `0` when the service worker is inactive or bypassed (e.g.
 * `ngsw-bypass` document uploads). A real gateway `504` is not included.
 */
export function isNetworkFailureStatus(status: number): boolean {
  return status === 0 || status === SW_NETWORK_ERROR_STATUS;
}
